export enum CancelReason {
  FINISHED_WORK = 0,
  MISSING_FEATURES = 1,
  TOO_DIFFICULT_TO_USER = 2,
  TOO_MANY_BUGS = 3,
  TOO_EXPENSIVE = 4,
  _SIZE = 5,
}
